export const formatNumber = (value: any, decimalPrecision: number = 2) => {
  return parseFloat(value).toLocaleString("es-AR", {
    minimumFractionDigits: decimalPrecision,
    maximumFractionDigits: decimalPrecision,
  });
};
